import axios, { AxiosError } from "axios";
import useSWR from "swr";
import { useSession } from "next-auth/react";
import { PPUBalanceInfo } from "services/ppu/types";

export const usePPUBalance = () => {
  const { data: session } = useSession();
  const baseKey = `/api/ppu/balance`;

  const { data, error } = useSWR(
    session ? baseKey : null,
    () => axios.get<PPUBalanceInfo>(baseKey),
    {
      // keepPreviousData: true,
    }
  );

  return {
    balance: data?.data,
    isBalanceLoading: !error && !data,
    isBalanceError: error as Error | AxiosError<PPUBalanceInfo>,
  };
};
